import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {lastValueFrom} from 'rxjs';
import {EventData} from '../event/EventData';
import {EnvironmentService} from '../EnvironmentService';
import {BotIdService} from '../BotIdService';

@Injectable({
    providedIn: 'root'
})
export class EventRessource {

    constructor(private http: HttpClient, private environmentService: EnvironmentService, private botIdService: BotIdService) {
    }

    public async recordEvent(msteamsId: string, eventData: EventData): Promise<string> {
        return lastValueFrom(this.http.post(`${this.environmentService.environment.serverUrl}/api/profile/tracker`, eventData, {responseType: 'text', params: {msteamsid: msteamsId}}));
    }

    public async recordEventForLearn(eventData: EventData): Promise<string> {
        return lastValueFrom(this.http.post(`${this.environmentService.environment.serverUrl}/api/learn/profile/tracker`, eventData, {responseType: 'text', params:{channel: this.botIdService.getBotId()}}));
    }

}
